import { SubscriptionTier } from './subscription-tiers';

export enum CompanySize {
  _10 = '0-10 M€',
  _100 = '10-100 M€',
  _1000 = '100-1000 M€',
  _10000 = '1000+ M€',
}

export const allCompanySizes = Object.values(CompanySize);

export const subscriptionFees = {
  [CompanySize._10]: 5000,
  [CompanySize._100]: 10000,
  [CompanySize._1000]: 15000,
  [CompanySize._10000]: 20000,
};

export type PersonalInfo = {
  firstName: string;
  lastName: string;
  email: string;
};

export type CompanyInfo = {
  name: string;
  size: CompanySize | undefined;
  companyId?: string;
};

export type SubscriptionRequest = {
  tier: SubscriptionTier;
  personalInfo: PersonalInfo;
  companyInfo: CompanyInfo;
  promoCode: string | undefined;
  message: string | undefined;
  password: string | undefined;
  gaClientId?: string;
};

export type SubscriptionResponse = {
  success?: true;
  emailVerificationLink?: string;
};
